const semanticClassNames = {
  root: 'video-player',
} as const;

export default semanticClassNames;
